export const skills = [
  {
    name: 'HTML5',
    icon: 'devicon-html5-plain',
  },
  {
    name: 'CSS3',
    icon: 'devicon-css3-plain',
  },
  {
    name: 'JavaScript',
    icon: 'devicon-javascript-plain',
  },
  {
    name: 'TypeScript',
    icon: 'devicon-typescript-plain',
  },
  {
    name: 'ReactJS',
    icon: 'devicon-react-original',
  },
  {
    name: 'Bootstrap',
    icon: 'devicon-bootstrap-plain',
  },
  {
    name: 'Tailwind CSS',
    icon: 'devicon-tailwindcss-plain',
  },
  {
    name: 'Redux',
    icon: 'devicon-redux-original',
  },
  {
    name: 'Jest',
    icon: 'devicon-jest-plain',
  },
  {
    name: 'Docker',
    icon: 'devicon-docker-plain',
  },
  {
    name: 'Git',
    icon: 'devicon-git-plain',
  },
  {
    name: 'GitHub',
    icon: 'devicon-github-original',
  },
  {
    name: 'MySQL',
    icon: 'devicon-mysql-plain',
  },
  {
    name: 'Mongo DB',
    icon: 'devicon-mongodb-plain',
  },
  {
    name: 'Node JS',
    icon: 'devicon-nodejs-plain',
  },
  {
    name: 'Express JS',
    icon: 'devicon-express-original',
  },
];

import chefPedia from '../images/chefPedia.png';
import storeManager from '../images/storeManager.png';
import eJobs from '../images/eJobs.png';

export const projects = [
  {
    image: {
      src: chefPedia,
      alt: 'Chef Pedia main page with some recipe cards'
    },
    name: 'Chef Pedia',
    description: 'A responsive web app to find recipes and drinks.',
    technologies: ['#React.js', '#Context API', '#Hooks', '#Tailwind CSS'],
    github: 'https://github.com/Matta-012/chef-pedia',
    deployLink: 'https://chefpedia.vercel.app/'
  },
  {
    image: {
      src: storeManager,
      alt: 'A print from Insomina app showing the routes of the API'
    },
    name: 'Store Manager',
    description: 'A CRUD for a RESTful API with a database to manage a store.',
    technologies: ['#Node.js', '#Express.js', '#MySQL', '#TDD'],
    github: 'https://github.com/Matta-012/store-manager',
  },
  {
    image: {
      src: eJobs,
      alt: 'eJobs hero page',
    },
    name: 'eJobs',
    description: 'A website to find jobs.',
    technologies: ['#JavaScript', '#Bootstrap', '#HTML', '#CSS'],
    github: 'https://github.com/Matta-012/adzuna',
    deployLink: 'https://ejobs.vercel.app/'
  },
];
